import React from "react";

export default React.forwardRef(function NextdoorIcon(props, ref) {
  return (
    <svg
      height="1em"
      viewBox="0 0 32 30"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M31.99 13.089l-15.99-9.792-5.495 3.365v-3.365h-5.005v6.427l-5.495 3.365 2.615 4.271 2.88-1.755v13.099h21v-13.099l2.875 1.755 2.615-4.271z"
        fill="#19975d"
      />
    </svg>
  );
});
